import { render, staticRenderFns } from "./AutorInput.vue?vue&type=template&id=db3a6a1c&"
import script from "./AutorInput.vue?vue&type=script&lang=js&"
export * from "./AutorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports